export const ADD_PRODUCT = "product/addproduct";
export const ADD_TO_CART = "product/addtocart";
export const ADD_QUANTITY = "product/addquantity";
export const REMOVE_QUANTITY = "product/removequantity";
export const DELETE_PRODUCT_FROM_CART = "product/deleteproductfromcart";
